// Email/notification deliverability (platform). Cross-tenant roll-up of the
// notification delivery log from notification-service. Platform-gated server-side.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface DeliveryTotals {
  sent: number;
  failed: number;
  suppressed: number;
  other: number;
  total: number;
}

export interface ChannelRow {
  channel: string;
  sent: number;
  failed: number;
  suppressed: number;
}

export interface TypeRow {
  type: string;
  total: number;
  failed: number;
  suppressed: number;
}

export interface IssueRow {
  recipient: string;
  type: string;
  channel: string;
  status: string;
  reason: string;
  created_at: string;
}

export interface Deliverability {
  window_days: number;
  totals: DeliveryTotals;
  delivery_rate: number;
  by_channel: ChannelRow[];
  by_type: TypeRow[];
  recent_issues: IssueRow[];
}

export const getDeliverability = (days = 30) =>
  axios
    .get<Deliverability>(`${API_V1}/notifications/platform/deliverability`, { params: { days } })
    .then((r) => r.data);
